import { SLOTS } from './slots.js'

const ADVENTURE_TYPE_BADGES = {
  reward: { label: 'Reward', badgeClass: 'badge-success' },
  event: { label: 'Event', badgeClass: 'badge-info' },
  ticket: { label: 'Ticket', badgeClass: 'badge-secondary' },
  group_required: { label: 'Group', badgeClass: 'badge-accent' },
  store_item: { label: 'Store Item', badgeClass: 'badge-warning' }
}

// Adventures: local deals/experiences scoped to a place. Money and geofence values arrive
// display-ready from AdventuresController#list_props.
export default {
  key: 'adventure',
  label: 'Adventure',
  icon: 'adventures',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.CONTEXT, field: 'place.name', label: 'Place', link: 'place.url' },
    { slot: SLOTS.METADATA, field: 'adventure_type', label: 'Type', renderer: 'state_badge', badges: ADVENTURE_TYPE_BADGES },
    { slot: SLOTS.METADATA, field: 'savings', label: 'Savings', align: 'right', nowrap: true },
    { slot: SLOTS.METADATA, field: 'spend', label: 'Spend', align: 'right', nowrap: true },
    { slot: SLOTS.METADATA, field: 'zupp_spend', label: 'Zupp Spend', align: 'right', nowrap: true },
    { slot: SLOTS.METADATA, field: 'point_source.label', label: 'Point Source', link: 'point_source.url' },
    { slot: SLOTS.METADATA, field: 'geofence', label: 'Geofence', nowrap: true },
    { slot: SLOTS.METADATA, field: 'active_times', label: 'Active Times', nowrap: true }
  ],
  empty: { icon: 'adventures', message: 'No adventures found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT] }
}
